import { Theme, Components } from '@mui/material/styles';

export const Tooltip: Components<Theme> = {
  MuiTooltip: {
    defaultProps: {
      arrow: true,
    },
    styleOverrides: {
      tooltip: ({ theme }) => ({
        textAlign: 'center',
        backgroundColor: '#F5A623',
        boxShadow: theme.shadows[5], //'0px 4px 32px rgba(0, 0, 0, 0.5)',
        color: '#FFFFFF',
        fontSize: 16,
        paddingTop: 12,
        paddingRight: 24,
        paddingBottom: 12,
        paddingLeft: 24,
      }),
      arrow: {
        color: '#F5A623',
      },
    },
  },
};
